import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Message } from 'primeng/api';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-manage-user-group',
  templateUrl: './manage-user-group.component.html',
  styleUrls: ['./manage-user-group.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class ManageUserGroupComponent implements OnInit {

  messages: Message[] = [];
  crumbs: MenuItem[];
  action = { 'addGroup': false, 'editGroup': false, 'listGroup': true };
  selectedUserGroup: {};
  existingGroupNames: any[];
  message: {};

  constructor() { }

  ngOnInit() {
    this.setBreadCrumbs([{ label: 'User Groups', disabled: true }]);
  }

  showHideAddUserGroup(displayDiv: boolean): void {
    if (displayDiv) {
      this.setBreadCrumbs([{ label: 'User Groups' }, { label: 'Add Group', disabled: true }]);
    }
    this.action['addGroup'] = displayDiv;
    this.action['listGroup'] = !displayDiv;
  }

  showHideEditUserGroup(displayDiv: boolean, userGroup: {}): void {
    if (displayDiv) {
      this.setBreadCrumbs([{ label: 'User Groups' }, { label: 'Edit Group', disabled: true }]);
    }
    this.action['editGroup'] = displayDiv;
    this.action['listGroup'] = !displayDiv;
  }

  setSelectedGroup(userGroup: {}): void {
    this.selectedUserGroup = userGroup;
  }

  setBreadCrumbs(elements: any[]): void {
    this.crumbs = elements;
  }

  setExistingGroupNames(existingGroupNames: any[]): void {
    this.existingGroupNames = existingGroupNames;
  }

  setMessage(message: {}): void {
    this.message = message;
  }

}